import React from "react";
import "./AboutCard.css";

const AboutCard: React.FC = () => {
  return (
    <section className="acard-section">
      <div className="container">
        <div className="acard-label">About Us — AJERA Infotech</div>
        <div className="acard-box">
          <div className="acard-text">
            <p>
              AJERA Infotech is a new-age technology company focused on delivering
              high-quality digital solutions and innovative software products.
            </p>
            <p>
              We started this company to solve real-life and business problems
              using modern technology and smart digital solutions.
            </p>
            <p>
              Our focus is on quality, innovation, and problem-solving through
              software, web, mobile, and cloud technologies.
            </p>
            <p>
              Our goal is to build technology that creates opportunities, solves
              problems, and improves the future.
            </p>
          </div>
          <div className="acard-img">
            <img src="/web4.avif" alt="About AJERA" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutCard;
